import React, { ReactElement } from 'react'
import { ChangeHandler, FieldErrors, UseFormWatch } from 'react-hook-form'

type TLeadFormValues = {
  name?: string
  phoneNumber: string
  email?: string
  promocode?: string
  pdfData?: {
    name: string
    url: string
  }[]
  price?: number | null
  personalDataAgreement: boolean
  marketingAgreement: boolean
}

type Props = {
  text: string
  register: {
    onChange: ChangeHandler
    onBlur: ChangeHandler
    ref: React.Ref<any>
    name: string
  }
  error?: FieldErrors<TLeadFormValues>
  watch: UseFormWatch<TLeadFormValues>
}

export const CheckBox: React.FC<Props> = ({ text, register, error, watch }) => {
  const fieldName = register.name as keyof TLeadFormValues
  const isChecked = watch(fieldName)
  const hasError = Boolean(error && error[fieldName])

  const getBorderColor = () => {
    if (hasError) return '#FF0000'
    if (isChecked) return '#3A52EE'
    return '#C4C4C4'
  }

  const getStrokeColor = () => {
    if (hasError) return '#FF0000'
    if (isChecked) return '#3A52EE'
    return 'transparent'
  }

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '15px',
        marginTop: '15px',
        cursor: 'pointer',
        userSelect: 'none'
      }}>
      <div style={{ position: 'relative', flexShrink: 0 }}>
        <input
          type='checkbox'
          {...register}
          style={{
            position: 'absolute',
            opacity: 0,
            width: '20px',
            height: '20px',
            cursor: 'pointer',
            margin: 0,
            zIndex: 2
          }}
        />
        <div
          style={{
            width: '20px',
            height: '20px',
            border: `1px solid ${getBorderColor()}`,
            borderRadius: '4px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none'
          }}>
          <svg
            width='11'
            height='8'
            viewBox='0 0 11 8'
            fill='none'
            style={{ opacity: isChecked ? 1 : 0 }}
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M9.83366 0.75L3.87533 6.70833L1.16699 4'
              stroke={getStrokeColor()}
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>
      <span style={{ fontSize: '12px', lineHeight: '1.1', color: '#8B8B8B' }}>
        {text}
      </span>
    </label>
  )
}
